// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"bf5f335b","599":"98e9a39b"}[chunkId] + ".chunk.js";
};